import React, { useEffect, useState } from "react";
import { Col, Form, Row, Spinner } from "react-bootstrap";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import { FaCircleXmark } from "react-icons/fa6";
import {
  useAddPollMutation,
  useUpdatePollMutation,
} from "../../Data/services/pollApi";
import { useUploadAttachmentMutation } from "../../Data/services/uploadAttachmentApi";
import Toast, { SuccessToast } from "../../Hooks/useToast";
import { Button, Input } from "../CustomComponents";
import ModalContainer from "../ModalContainer";
import cssStyles from "./styles/editModal.module.scss";
import SelectFieldComponent from "../CustomComponents/SelectFieldComponent";
import _ from "lodash";
import { formatDateTimeLocal } from "../../Helper";

const EditPollModal = ({
  handleEditModalClose,
  categoryList,
  editData,
  refetch,
}) => {
  const {
    handleSubmit,
    control,
    formState: { errors },
    setValue,
  } = useForm({
    defaultValues: {
      category_id: "",
      topic: "",
      description: "",
      start_at: "",
      end_at: "",
      vote_amount: 1,
      options: [{ option: "" }],
    },
  });

  console.log(editData);

  const { fields, append, remove } = useFieldArray({
    control,
    name: "options",
  });

  const [rowId, setRowId] = useState("");
  const [sending, setSending] = useState(false);

  const [imageUrl, setImageUrl] = useState("");
  const [imageFile, setImageFile] = useState("");
  const [imagePreview, setImagePreview] = useState("");

  const [selectedCategory, setSelectedCategory] = useState("");

  const handleCategoryChange = (value) => {
    console.log(value);
    setSelectedCategory(value);
  };

  const [mounted, setMounted] = React.useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (editData) {
      setRowId(editData.id);
      setValue("category_id", parseInt(editData.category_id) || "");
      setSelectedCategory(parseInt(editData.category_id));
      setValue("topic", editData.topic || "");
      setValue("description", editData.description || "");
      setValue("start_at", formatDateTimeLocal(editData.start_at));
      setValue("end_at", formatDateTimeLocal(editData.end_at));
      // setValue("vote_amount", editData.vote_amount);
      setValue("options", editData.options || [{ option: "" }]);
      setImageUrl(editData.attachments?.[0]?.media_url || "");
    }
  }, [editData, mounted, setValue]);

  const [uploadAttachment, { isLoading: isUploading }] =
    useUploadAttachmentMutation();

  const handleImagePreview = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (file) {
      setImageFile(file);
      setImagePreview(URL.createObjectURL(file));
    }
  };

  const handleImageUpload = async (e) => {
    const formData = new FormData();
    formData.append("file", imageFile);
    formData.append("path", "admin");

    // Loop through formData
    for (let [key, value] of formData.entries()) {
      console.log(key, value);
    }

    try {
      const response = await uploadAttachment({ formData }).unwrap();
      console.log(response);
      return response.data[0];
    } catch (error) {
      Toast("Failed to upload image", "error");
    }
  };

  const [addPoll, { isLoading: adding }] = useAddPollMutation();
  const [updatePoll, { isLoading: updating }] = useUpdatePollMutation();

  const handleSave = async (data) => {
    console.log(rowId);

    let imageName;
    if (imageFile) {
      imageName = await handleImageUpload();
    }

    const payload = {
      ...data,
      category_id: parseInt(selectedCategory),
      attachments:
        imageName || imageUrl
          ? [{ media_type: "image", media_url: imageName || imageUrl }]
          : [],
    };

    console.log(data);
    console.log(payload);

    setSending(true);
    try {
      let response;
      if (editData) {
        response = await updatePoll({ data: payload, id: rowId }).unwrap();
      } else {
        response = await addPoll(payload).unwrap();
      }

      console.log(response);

      if (response.code === 200) {
        refetch();
        setSending(false);
        SuccessToast(response?.message);
        handleEditModalClose();
      }
    } catch (error) {
      console.log(error);
      if (error?.response && error?.response?.data?.message) {
        Toast(error?.response?.data?.message, "error");
      } else {
        Toast("An error occurred during login", "error");
      }
      handleEditModalClose();
      setSending(false);
    }
  };

  if (!mounted) {
    return;
  }

  return (
    <div>
      <ModalContainer handleClose={handleEditModalClose}>
        <div className={cssStyles.modalContainer} style={{ minWidth: "90%" }}>
          <div className="d-flex align-items-center w-100 justify-content-between mb-4">
            <p className="fs-4 fw-medium m-0 ">
              {editData ? "Edit Poll" : "Add Poll"}
            </p>
            <span className="bg-dark bg-opacity-75 d-flex p-3 rounded-5">
              <FaCircleXmark
                role="button"
                onClick={handleEditModalClose}
                style={{ cursor: "pointer" }}
              />
            </span>
          </div>
          <div className="w-100">
            <Form onSubmit={handleSubmit(handleSave)}>
              <Row>
                {/* Category Dropdown */}
                <Col md={6} sm={12}>
                  <p className="m-0">Category</p>

                  <SelectFieldComponent
                    firstOption={
                      selectedCategory ? selectedCategory : "Select Category"
                    }
                    optionsList={categoryList}
                    onSelectChange={handleCategoryChange}
                  />
                  {/* <Controller
                    control={control}
                    name="category_id"
                    rules={{ required: "Category is required" }}
                    render={({ field: { onChange, value } }) => {
                      const selectedLabel =
                        categoryList.find(
                          (category) => category.value === value
                        )?.label || "Select Category";
                      return (
                        <SelectFieldComponent
                          // value={value}
                          firstOption={
                            !editData
                              ? !value
                                ? "Select Category"
                                : value
                              : selectedLabel
                          }
                          optionsList={categoryList}
                          onSelectChange={onChange}
                        />
                      );
                    }}
                  />
                  {errors?.category_id && (
                    <p className="text-danger">{errors.category_id.message}</p>
                  )} */}
                  {/* Topic */}
                  <p className="m-0">Topic</p>
                  <Controller
                    control={control}
                    name="topic"
                    rules={{ required: "Topic is required" }}
                    render={({ field }) => (
                      <Input
                        classes="mt-2 mb-3"
                        type="text"
                        placeholder="Enter topic"
                        {...field}
                      />
                    )}
                  />

                  {/* Start and End Date */}
                  <div className="d-flex justify-content-between gap-2">
                    <span className="w-100">
                      <p className="m-0">Start At</p>
                      <Controller
                        control={control}
                        name="start_at"
                        render={({ field }) => (
                          <Input
                            classes="mt-2 mb-3"
                            type="datetime-local"
                            {...field}
                          />
                        )}
                      />
                    </span>
                    <span className="w-100">
                      <p className="m-0">End At</p>
                      <Controller
                        control={control}
                        name="end_at"
                        render={({ field }) => (
                          <Input
                            classes="mt-2 mb-3"
                            type="datetime-local"
                            {...field}
                          />
                        )}
                      />
                    </span>
                  </div>

                  {/* Vote Amount */}
                  {/* {editData ? (
                    ""
                  ) : (
                    <>
                      <p className="m-0">Vote Amount</p>
                      <Controller
                        control={control}
                        name="vote_amount"
                        render={({ field }) => (
                          <Input
                            classes="mt-2 mb-3"
                            type="number"
                            placeholder="Enter vote amount"
                            {...field}
                          />
                        )}
                      />
                    </>
                  )} */}

                  {/* Description */}
                  <p className="m-0">Description</p>
                  <Controller
                    control={control}
                    name="description"
                    rules={{ required: "Description is required" }}
                    render={({ field }) => (
                      <Input
                        as="textarea"
                        type="textarea"
                        rows={5}
                        className="form-control mt-2 mb-3"
                        placeholder="Enter description"
                        {...field}
                      />
                    )}
                  />
                </Col>

                <Col md={6} sm={12}>
                  {/* Options List */}
                  <p className="m-0">Options</p>
                  {fields.map((field, index) => (
                    <div key={field.id} className="d-flex gap-2 mt-2 w-100">
                      <Controller
                        control={control}
                        name={`options.${index}.option`}
                        render={({ field }) => (
                          <Input
                            classes="flex-grow-1"
                            type="text"
                            placeholder={`Option ${index + 1}`}
                            {...field}
                          />
                        )}
                      />
                      <Button
                        type="button"
                        style={{ width: "40px" }}
                        classes="btn btn-danger bg-danger rounded-circle"
                        text="X"
                        onClick={() => remove(index)}
                      />
                    </div>
                  ))}
                  <Button
                    type="button"
                    style={{ width: "200px" }}
                    classes="btn btn-success"
                    text="Add Option"
                    onClick={() => append({ option: "" })}
                  />

                  {/* Image Upload */}
                  <p className="m-0 mt-3">Attachment</p>
                  <Input
                    type="file"
                    onChange={(e) => {
                      // handleImageUpload(e);
                      handleImagePreview(e);
                    }}
                    classes="mt-2 mb-3"
                  />
                  {isUploading ? (
                    <Spinner />
                  ) : (
                    <img
                      src={
                        imagePreview ||
                        imageUrl ||
                        "https://placehold.co/100x100"
                      }
                      alt="category_image"
                      width={100}
                      height={100}
                      className="rounded"
                    />
                  )}

                  {/* Save Button */}
                  <Button
                    type="submit"
                    classes={`${cssStyles.cardBtn} mt-4 `}
                    text={
                      sending ? (
                        <Spinner
                        // animation="grow"
                        // size="sm"
                        // className="mx-3 my-1"
                        />
                      ) : editData ? (
                        "Update"
                      ) : (
                        "Save"
                      )
                    }
                  />
                </Col>
              </Row>
            </Form>
          </div>
        </div>
      </ModalContainer>
    </div>
  );
};

export default EditPollModal;
